import '@/i18n'
import React, { Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import { ClerkProvider } from '@clerk/clerk-react'
import { Providers } from './providers'
import { router } from '@/config/router'
import { OpenAppBanner } from '@/components/share/OpenAppBanner'

// Clerk Configuration
const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

// 根级 Suspense fallback：用于 Layout 之外的顶级懒加载路由（register、forgot-password 等）。
// 故意做得极简，避免引入额外依赖、保持 first paint 时的体积。
const RootFallback = () => (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    fontFamily: 'Inter, system-ui, sans-serif',
    /* dark-ok: 根级 fallback 渲染在 ThemeProvider 就绪之前，语义变量此时可能未定义；
       slate-400 在亮暗两种底色上都可读 */
    color: '#94a3b8',
    fontSize: 14,
  }}>
    Loading…
  </div>
)

function Root() {
  // The OpenAppBanner is intentionally a sibling of <RouterProvider>, not a
  // descendant — see src/components/share/OpenAppBanner.tsx for the rationale
  // (works on /login, doesn't depend on react-router hooks, doesn't rerender
  // on SPA navigation).
  const inner = (
    <Providers>
      <OpenAppBanner />
      <Suspense fallback={<RootFallback />}>
        <RouterProvider router={router} />
      </Suspense>
    </Providers>
  )

  if (!CLERK_PUBLISHABLE_KEY) {
    console.warn('[Auth] No Clerk publishable key found, using legacy auth only')
    return inner
  }

  return (
    <ClerkProvider
      publishableKey={CLERK_PUBLISHABLE_KEY}
      afterSignOutUrl="/login"
      routerPush={(to) => router.navigate(to)}
      routerReplace={(to) => router.navigate(to, { replace: true })}
    >
      {inner}
    </ClerkProvider>
  )
}

export default Root
